import { makeStyles } from '@material-ui/core/styles';
import { navBarHeight } from 'UI/constants/dimensions';

export const useResponsiveFilterLayoutStyles = makeStyles(theme => ({
  mainGrid: ({ isLargeScreen }) => ({
    display: 'grid',
    gridTemplateColumns: isLargeScreen ? '430px 1fr' : '1fr',
    height: `calc(100vh - ${navBarHeight}px)`,
    width: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box'
  }),
  leftPanel: ({ isLargeScreen }) => ({
    display: isLargeScreen ? 'block' : 'none',
    height: '100%',
    overflow: 'auto',
    backgroundColor: theme.palette.grey[100],
    borderRight: `1px solid ${theme.palette.divider}`
  }),
  rightPanel: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper
  }
}));
